import _ from 'lodash';
import { LocalStorageKeys } from '@/constants/LocalStorageKeys';
import IComp from '@/models/Comp';
import DoubleIndex from '@/models/DoubleIndex';
import IFeedData, { newFeedData } from '@/models/comp/IFeedData';
import SmartExchangeRequest from '@/models/requests/SmartExchangeRequest';
import GridColumnUtils from '@/utils/GridColumnUtils';
import theLocalStorageUtils from '@/utils/LocalStorageUtils';
import Utils from '@/utils/QSUtils';
import { computed } from 'vue';
import { Actions, Getters, store, mlsStore, Mutations, formFieldsStore } from '..';
import CompDataFeedsRequest from './models/CompDataFeedsRequest';
import UpdateFeedRequest from './models/UpdateFeedRequest';
import UAD from '@/services/2.6/uad/UAD';
import { FieldParser } from '@/services/2.6/uad/FieldParser';
import ISourceData from '@/models/comp/ISourceData';
import ICommonFieldData from '@/models/common/ICommonFieldData';
import IComps from '@/models/comp/IComps';
import { FieldNames } from '@/constants/FieldNames';
import IFormFieldRules from '@/models/form-field/IFormFieldRules';
import CompUtils from '@/models/comp/CompUtils';
import PublicRecordsFeedHelper from './helpers/PublicRecordsFeedHelper';
import CompDatasUtils from '@/models/comp/CompDatasUtils';
import LocalCompHelper from './helpers/LocalCompHelper';
import SmartExchangeFeedHelper from './helpers/SmartExchangeFeedHelper';
import { SourceDataInitials } from '@/constants/SourceDataInitials';
import { newCompData } from '@/models/comp/ICompData';
import IRunFieldPrefsRequest, { newRunFieldPrefsRequest } from './models/RunFieldPrefsRequest';
import IProcessCompRequest, { newProcessCompRequest } from './models/IProcessCompRequest';
import ICompDatas from '@/models/comp/ICompDatas';
import FieldRulesHelper from './helpers/FieldRulesHelper';
import { FieldIds } from '@/constants/FieldIds';
import SmartExchangeClaimsHelper from './helpers/SmartExchangeClaimsHelper';
import IWorkingUADParams from '@/models/uad/IWorkingUADParams';
import UserSettingsHelper from '@/store/2.6/helpers/UserSettingsHelper';
import ICompAddress from '@/models/CompAddress';
import IAddCompDataRequest from './models/IAddCompDataRequest';
import CompsHelper from './helpers/CompsHelper';
import FormsHelper from './helpers/FormsHelper';
import FormsManager from '@/manager/2.6/FormsManager';
import CompAddressUtils from '@/models/comp/CompAddressUtils';
import IUpsertCompDataRequest, { newUpsertCompDataRequestByFieldId, newUpsertCompDataRequestByFieldName } from './models/IUpsertCompDataRequest';
import IClearSourceDataRequest from '@/models/requests/IClearSourceDataRequest';
import CompPrioritiesHelper from './helpers/CompPrioritiesHelper';
import CompTranslationsHelper from './helpers/CompTranslationsHelper';

export const CompAddressGetters = {
    Comps: 'Comps',
    CompCount: 'CompCount',
    CompByIdx: 'CompByIdx',
    HasComps: 'HasComps',
    ActiveComp: 'ActiveComp',
    CompByAddress: 'CompByAddress',
    LocalDatabaseCompByAddress: 'LocalDatabaseCompByAddress',
    CompIdxByAddress: 'CompIdxByAddress',
    ActiveFormCode: 'ActiveFormCode',
    GetAllDataPointsByFieldId: 'GetAllDataPointsByFieldId',
    ActiveCompFieldData: 'ActiveCompFieldData',
    OnlyShowDiscrepancyRows: 'OnlyShowDiscrepancyRows',
    ActiveCompEmptySourceData: 'ActiveCompEmptySourceData',
    GetFakeData: 'GetFakeData',
    ActiveCompFieldFillerCount: 'activeCompFieldFillerCount',
    ActiveCompSourceCounts: 'activeCompSourceCounts',
    IsSEColumnCollasped: 'isSEColumnCollasped',
    IsDBColumnCollasped: 'isDBColumnCollasped',
    GetCompSourceDataValueByFieldName: 'GetCompSourceDataValueByFieldName',
    GetCompSourceDataValueByFieldId: 'GetCompSourceDataValueByFieldId',
    LocalDatabaseComps: 'LocalDatabaseComps',
};

export const CompAddressActions = {
    ProcessComps: 'ProcessComps',
    ProcessComp: 'ProcessComp',
    FetchCompDataFeeds: 'FetchCompDataFeeds',
    ReFetchCompDataFeeds: 'ReFetchCompDataFeeds',
    FetchCompSmartExchangeData: 'FetchCompSmartExchangeData',
    MoveComp: 'MoveComp',
    RemoveComp: 'RemoveComp',
    TransferValueTranslations: 'TransferValueTranslations',
    TransferRunAllFieldDataPreferences: 'TransferRunAllFieldDataPreferences',
    UseAllData: 'UseAllData',
    UseAllSubCompData: 'UseAllSubCompData',
    ProcessUseAllData: 'ProcessUseAllData',
    OnlyShowDiscrepancyRows: 'OnlyShowDiscrepancyRows',
    TransferRunFieldRowTransferValueRulesOnAllCompsByFieldId: 'TransferRunFieldRowTransferValueRulesOnAllCompsByFieldId',
    TransferRunFieldRowTransferValueRulesOnCompsProcess: 'TransferRunFieldRowTransferValueRulesOnCompsProcess',
    TransferRunFieldRowTransferValueCasingOnAllComps: 'TransferRunFieldRowTransferValueCasingOnAllComps',
    TransferRunFieldRowTransferValueCasingOnAllCompsByFieldId: 'TransferRunFieldRowTransferValueCasingOnAllCompsByFieldId',
    TransferRunFieldRowTransferValueCasingOnAllUnVisitedCompsByFieldId: 'TransferRunFieldRowTransferValueCasingOnAllUnVisitedCompsByFieldId',
    TransferRunFieldRowTransferValueCasingOnCompsProcess: 'TransferRunFieldRowTransferValueCasingOnCompsProcess',
    UpdateAdditionalField: 'UpdateAdditionalField',
    GenerateFakeData: 'GenerateFakeData',
    UpdateInsertNotes: 'UpdateInsertNotes',
    ActiveCompFieldFillerCount: 'activeCompFieldFillerCount',
    ActiveCompSourceCounts: 'activeCompSourceCounts',
    LocalDatabaseComps: 'LocalDatabaseComps',
    UpdateLocalVersions: 'UpdateLocalVersions',
};

export const CompAddressMutations = {
    AddCompData: 'AddCompData',
    UpdateComp: 'UpdateComp',
    UpdateCompMLS: 'UpdateCompMLS',
    UpdateHasComps: 'UpdateHasComps',
    UpdateCompFeedData: 'UpdateCompFeedData',
    ResetCompLoading: 'ResetCompLoading',
    UpdateRemoveComp: 'UpdateRemoveComp',
    UpdateActiveComp: 'UpdateActiveComp',
    UpdateMoveComp: 'UpdateMoveComp',
    ResetActiveComp: 'ResetActiveComp',
    ResetCompNumber: 'ResetCompNumber',
    UpsertCompSourceDataByFieldId: 'UpsertCompSourceDataByFieldId',
    UpsertCompSourceDataByFieldName: 'UpsertCompSourceDataByFieldName',
    UpsertCompSourceDataValueByFieldName: 'UpsertCompSourceDataValueByFieldName',
    OnlyShowDiscrepancyRows: 'OnlyShowDiscrepancyRows',
    UpdateAdditionalField: 'UpdateAdditionalField',
    SetFakeData: 'SetFakeData',
    UpdateInsertNotes: 'UpdateInsertNotes',
    ActiveCompFieldFillerCount: 'activeCompFieldFillerCount',
    ActiveCompSourceCounts: 'activeCompSourceCounts',
    AddSubComp: 'addSubComp',
    ClearSubComps: 'clearSubComps',
    SetSEColumnCollasped: 'setSEColumnCollasped',
    SetDBColumnCollasped: 'setDBColumnCollasped',
    ClearCompSourceData: 'ClearCompSourceData',
    LocalDatabaseComps: 'LocalDatabaseComps',
    UpdateLocalVersions: 'UpdateLocalVersions',
};

export const CompAddressStore = {
    namespaced: true,

    state() {
        const comps: IComp[] = [];
        const activeComp: IComp | null = null;
        const activeCompSourceCounts: IFeedData[] = [];
        const fakeData: ISourceData = {};
        const activeCompSubComps: IComp[] = [];
        const localDatabaseComps: IComp[] = [];

        return {
            comps,
            hasComps: false,
            activeFormCode: theLocalStorageUtils.get(LocalStorageKeys.formCode),
            activeCompFieldFillerCount: 0,
            activeCompSourceCounts,
            activeComp,
            activeCompSubComps,
            activeCompIsSECollapsed: true,
            activeCompIsdBCollapsed: true,
            onlyShowDiscrepancyRows: false,
            fakeData,
            localDatabaseComps,
        };
    },

    actions: {
        async [CompAddressActions.LocalDatabaseComps](ctx: any, comp: IComp) {
            ctx.commit(CompAddressMutations.LocalDatabaseComps, comp);
        },
        async [CompAddressActions.UpdateLocalVersions](ctx: any, payload: any) {
            ctx.commit(CompAddressMutations.UpdateLocalVersions, payload);
        },
        async [CompAddressActions.ProcessComps](ctx: any, comps: IComps) {
            for (const idx in comps) {
                const processCompRequest = newProcessCompRequest(comps[idx]);
                ctx.dispatch(CompAddressActions.ProcessComp, processCompRequest);
            }

            const activeCompIdx = Number(theLocalStorageUtils.get(LocalStorageKeys.defaultComp) ?? 0);
            CompsHelper.setActiveComp(activeCompIdx);

            ctx.dispatch(CompAddressActions.GenerateFakeData);
        },
        async [CompAddressActions.ProcessComp](ctx: any, request: IProcessCompRequest) {
            const getterComps = store.getters[Getters.CompAddresses.Comps];

            // Skip address with missing address1 and zipcode
            const comp = request.comp;
            if (comp.address.address1 === '' || comp.address.zipCode === '') {
                return;
            }

            // Exclude duplicate comp based on address1 and unit number
            const itemIdx = store.getters[Getters.CompAddresses.CompIdxByAddress](comp.address);
            if (itemIdx === -1) {
                if (Utils.objectSize(getterComps) >= 1) {
                    ctx.commit(CompAddressMutations.UpdateHasComps, true);
                }

                comp.address.address2 = GridColumnUtils.buildAddress2(comp.address);
                comp.compKey = Utils.isKeyInObject(comp, 'compKey') ? comp.compKey : '';
                comp.compNumber = getterComps.length;
                comp.compType = Utils.isKeyInObject(comp, 'compType') ? comp.compType : 'Sale';
                comp.formCode = comp.formCode ? comp.formCode : theLocalStorageUtils.get(LocalStorageKeys.formCode) ?? '';
                comp.isActive = false;
                comp.isLoading = true;
                comp.isSubject = comp.compType ? (comp.compType.toLowerCase() === 'subject' ? true : false) : false;
                comp.localVersions = Utils.isKeyInObject(comp, 'localVersions') ? comp.localVersions : [];
                comp.notesData = Utils.isKeyInObject(comp, 'notesData') ? comp.notesData : [];
                comp.propertyPhoto = Utils.isKeyInObject(comp, 'propertyPhoto') ? comp.propertyPhoto : '';
                comp.qsGuid = Utils.uuid();

                if (!Utils.isKeyInObject(comp, 'sourceData')) {
                    comp.sourceData = [];
                    comp.hasVisited = false;
                } else {
                    comp.hasVisited = CompDatasUtils.hasInitialsOtherThanFormFiller(comp.sourceData);
                }

                ctx.commit(CompAddressMutations.UpdateComp, comp);

                const feedsRequest: CompDataFeedsRequest = {
                    address: comp.address,
                    qsGuid: comp.qsGuid,
                    formCode: comp.formCode ?? '',
                    compsGuid: theLocalStorageUtils.get(LocalStorageKeys.almCompId) ?? '',
                    isSubject: comp.isSubject,
                    fetch: [SourceDataInitials.PublicRecords, SourceDataInitials.SmartExchange, SourceDataInitials.Database, SourceDataInitials.Mls],
                };
                ctx.dispatch(CompAddressActions.FetchCompDataFeeds, feedsRequest);
            } else {
                // Check to see if MLS exists in duplicate payload.
                if (comp.sourceDataMLS) {
                    const formCode = theLocalStorageUtils.get(LocalStorageKeys.formCode);
                    const claims = await SmartExchangeClaimsHelper.getClaims();
                    const uadParams: IWorkingUADParams = {
                        parser: new FieldParser() as any,
                        formCode: formCode ?? '',
                        sourceInitial: SourceDataInitials.Mls,
                        sourceData: comp.sourceDataMLS.sourceData ?? {},
                        isSEOptedIn: claims.isOptedIn ?? false,
                    };
                    comp.sourceDataMLS.sourceData = await UAD.parser(uadParams);

                    ctx.commit(CompAddressMutations.UpdateCompMLS, {
                        idx: itemIdx,
                        mlsData: comp.sourceDataMLS,
                    });

                    // Only rerun the DataPreferences / ValueTranslations if comp has not been visited
                    const storeComps = store.getters[Getters.CompAddresses.Comps];
                    const storeComp = storeComps[itemIdx];
                    if (!storeComp.hasVisited || request.onUpdateRunPreferencesWhenHasVisited) {
                        await CompsHelper.backFillMissingFields(storeComp.address);

                        //console.log(`CompAddressStore.ProcessComp(Action), address[${CompAddressUtils.getShortDescription(comp.address)}], Dispatching TransferRunAllFieldDataPreferences`);
                        const runFieldPrefs = newRunFieldPrefsRequest(storeComp);
                        runFieldPrefs.overrideSourceInitial = true;
                        await ctx.dispatch(CompAddressActions.TransferRunAllFieldDataPreferences, runFieldPrefs);

                        //console.log(`CompAddressStore.ProcessComp(Action), address[${CompAddressUtils.getShortDescription(comp.address)}], Dispatching TransferValueTranslations`);
                        await ctx.dispatch(CompAddressActions.TransferValueTranslations, storeComp);
                    }
                }
            }
        },
        async [CompAddressActions.FetchCompDataFeeds](ctx: any, feedsRequest: CompDataFeedsRequest) {
            for (const idx in feedsRequest.fetch) {
                let feedData: IFeedData = {};
                switch (feedsRequest.fetch[idx].toLowerCase()) {
                    case SourceDataInitials.Database:
                        feedData = await LocalCompHelper.fetchFeedData(feedsRequest);
                        // Need to get subComps for each address for both the phot gallery and photo view button count
                        await LocalCompHelper.fetchFeedDataSubComps(feedsRequest);
                        break;
                    case SourceDataInitials.SmartExchange:
                        feedData = await ctx.dispatch(CompAddressActions.FetchCompSmartExchangeData, feedsRequest);
                        // Need to get subComps for each address for both the phot gallery and photo view button count
                        await SmartExchangeFeedHelper.fetchFeedDataSubComps(feedsRequest);
                        break;
                    case SourceDataInitials.PublicRecords:
                        {
                            const prFeedData = await PublicRecordsFeedHelper.fetch(feedsRequest);
                            feedData = prFeedData ? prFeedData : newFeedData();
                        }
                        break;
                    case SourceDataInitials.Mls:
                        {
                            const mlsPropertyItem = mlsStore.MlsPropertyFieldValueByAddress(feedsRequest.address);
                            feedData = {
                                sourceData: mlsPropertyItem ? mlsPropertyItem : {},
                            };
                        }
                        break;
                }

                // UAD parser
                if (Utils.isKeyInObject(feedData, 'sourceData') && !Utils.isObjectEmpty(feedData.sourceData)) {
                    const formCode = theLocalStorageUtils.get(LocalStorageKeys.formCode);
                    const claims = await SmartExchangeClaimsHelper.getClaims();
                    const uadParams: IWorkingUADParams = {
                        parser: new FieldParser() as any,
                        formCode: formCode ?? '',
                        sourceInitial: feedsRequest.fetch[idx].toLowerCase(),
                        sourceData: feedData.sourceData ?? {},
                        isSEOptedIn: claims.isOptedIn ?? false,
                    };
                    feedData.sourceData = await UAD.parser(uadParams);
                }

                const updateFeedRequest: UpdateFeedRequest = {
                    feedData: feedData,
                    qsGuid: feedsRequest.qsGuid,
                    sourceInitial: feedsRequest.fetch[idx].toLowerCase(),
                };

                ctx.commit(CompAddressMutations.UpdateCompFeedData, updateFeedRequest);
            }
            ctx.commit(CompAddressMutations.ResetCompLoading, feedsRequest.qsGuid);

            //Run transfer column updates
            const comps = computed(() => store.getters[Getters.CompAddresses.Comps]);
            const compIdx = comps.value.findIndex((f: any) => f.qsGuid === feedsRequest.qsGuid);
            if (compIdx !== -1) {
                const comp = comps.value[compIdx];
                await CompsHelper.backFillMissingFields(comp.address);

                //console.log(`CompAddressStore.FetchCompDataFeeds(Action), address[${CompAddressUtils.getShortDescription(comp.address)}], Dispatching TransferRunAllFieldDataPreferences`);
                const runFieldPrefs = newRunFieldPrefsRequest(comp);
                await ctx.dispatch(CompAddressActions.TransferRunAllFieldDataPreferences, runFieldPrefs);
                //console.log(`CompAddressStore.FetchCompDataFeeds(Action), address[${CompAddressUtils.getShortDescription(comp.address)}], Dispatching TransferValueTranslations`);
                await ctx.dispatch(CompAddressActions.TransferValueTranslations, comp);
            }
        },
        async [CompAddressActions.ReFetchCompDataFeeds](ctx: any, payload: any) {
            const feedsRequest: CompDataFeedsRequest = {
                address: payload.comp.address,
                qsGuid: payload.comp.qsGuid,
                formCode: payload.comp.formCode ?? '',
                compsGuid: theLocalStorageUtils.get(LocalStorageKeys.almCompId) ?? '',
                isSubject: payload.comp.isSubject,
                fetch: payload.refetch,
            };
            ctx.dispatch(CompAddressActions.FetchCompDataFeeds, feedsRequest);
        },
        async [CompAddressActions.FetchCompSmartExchangeData](ctx: any, feedsRequest: CompDataFeedsRequest): Promise<IFeedData> {
            const p2id = theLocalStorageUtils.get(LocalStorageKeys.p2id);

            const claims = await SmartExchangeClaimsHelper.getClaims();
            const seRequest: SmartExchangeRequest = {
                formCode: feedsRequest.formCode,
                isSubject: feedsRequest.isSubject,
                address: feedsRequest.address,
                p2Id: p2id ?? '',
                isOptedIn: claims.isOptedIn ?? false,
                optInUrl: claims.optInUrl ?? '',
                userAccessToken: claims.userAccessToken ?? '',
            };

            const result = await SmartExchangeFeedHelper.fetch(seRequest);
            return result;
        },
        [CompAddressActions.RemoveComp](ctx: any, idx: number) {
            ctx.commit(CompAddressMutations.UpdateRemoveComp, idx);
            ctx.commit(CompAddressMutations.ResetCompNumber);
        },
        [CompAddressActions.MoveComp](ctx: any, indexes: DoubleIndex) {
            ctx.commit(CompAddressMutations.UpdateMoveComp, indexes);
            ctx.commit(CompAddressMutations.ResetCompNumber);
        },
        async [CompAddressActions.TransferRunAllFieldDataPreferences](ctx: any, payload: IRunFieldPrefsRequest) {
            // If comp is subject and SubjectCascade is disabled then do not run data preferences
            const runSubjectCascade = payload.comp.isSubject && UserSettingsHelper.isSubjectCascadeDisabled() ? false : true;

            const compSourceData: ICompDatas = payload.comp.sourceData ? _.cloneDeep(payload.comp.sourceData) : [];
            const formFields = await FormsHelper.getFormFields();

            for (const fieldData of formFields) {
                const compData = compSourceData.find((cd) => cd.fieldName === fieldData.fieldName);
                if (compData) {
                    const request = newUpsertCompDataRequestByFieldName(payload.comp, fieldData.fieldName);
                    request.fieldId = fieldData.fieldId;
                    request.fieldRulesApplied = false;
                    request.description = 'CompAddressStore.TransferRunAllFieldDataPreferences()';
                    store.commit(Mutations.CompAddresses.UpsertCompSourceDataByFieldName, request);

                    // Skip all form filler comp data and any comp data with some source initial unless explicitly overridden
                    // We don't normally want to overwrite the Data Preference Order
                    if (compData.sourceInitial === SourceDataInitials.FormFiller || (!payload.overrideSourceInitial && compData.sourceInitial !== '')) {
                        continue;
                    } else if (compData.sourceInitial === '' && compData.value !== '') {
                        // If field data has a value but the sourceInitial is empty, treat is as FF
                        const request = newUpsertCompDataRequestByFieldName(payload.comp, fieldData.fieldName);
                        request.sourceInitial = SourceDataInitials.FormFiller;
                        request.description = 'CompAddressStore.TransferRunAllFieldDataPreferences()';
                        store.commit(Mutations.CompAddresses.UpsertCompSourceDataByFieldName, request);

                        continue;
                    }
                }

                if (!runSubjectCascade) {
                    continue;
                }

                // Run Data Priorities based on user priorities
                CompPrioritiesHelper.runOnField(payload.comp, fieldData.fieldId);
            }
        },
        [CompAddressActions.UpdateAdditionalField](ctx: any, payload: any) {
            ctx.commit(CompAddressMutations.UpdateAdditionalField, payload);
        },
        async [CompAddressActions.TransferValueTranslations](ctx: any, comp: IComp) {
            if (comp.sourceData) {
                const excludeNoValueAndNoSourceInitial = comp.compNumber === 0 && UserSettingsHelper.isSubjectCascadeDisabled();
                await CompTranslationsHelper.run(comp, excludeNoValueAndNoSourceInitial);
            }
        },
        [CompAddressActions.TransferRunFieldRowTransferValueRulesOnAllCompsByFieldId](ctx: any, fieldId: number) {
            const getterComps = store.getters[Getters.CompAddresses.Comps];
            for (const idx in getterComps) {
                const comp = getterComps[idx];

                store.dispatch(Actions.CompAddresses.TransferRunFieldRowTransferValueRulesOnCompsProcess, {
                    comp: comp,
                    fieldId: fieldId,
                });
            }
        },
        async [CompAddressActions.TransferRunFieldRowTransferValueRulesOnCompsProcess](ctx: any, payload: any) {
            const comp: IComp = payload.comp;
            const fieldId: number = payload.fieldId;
            if (comp.compNumber === 0 && UserSettingsHelper.isSubjectCascadeDisabled()) {
                // Return if Subject transfer column is locked
                return;
            }

            await CompTranslationsHelper.runOnField(comp, fieldId);
        },
        async [CompAddressActions.TransferRunFieldRowTransferValueCasingOnAllComps](ctx: any) {
            const getterComps = store.getters[Getters.CompAddresses.Comps];
            const formFields = await FormsHelper.getFormFields();
            for (const idx in getterComps) {
                const comp = getterComps[idx];
                for (const fieldIdx in formFields) {
                    const fieldId = formFields[fieldIdx].fieldId;
                    if (fieldId === FieldIds.CompPhoto) {
                        // Skip comp photo casing because of photo url
                        continue;
                    }

                    store.dispatch(Actions.CompAddresses.TransferRunFieldRowTransferValueCasingOnCompsProcess, {
                        comp: comp,
                        fieldId: fieldId,
                    });
                }
            }
        },
        [CompAddressActions.TransferRunFieldRowTransferValueCasingOnAllCompsByFieldId](ctx: any, fieldId: number) {
            const getterComps = store.getters[Getters.CompAddresses.Comps];
            for (const idx in getterComps) {
                const comp = getterComps[idx];

                store.dispatch(Actions.CompAddresses.TransferRunFieldRowTransferValueCasingOnCompsProcess, {
                    comp: comp,
                    fieldId: fieldId,
                });
            }
        },
        [CompAddressActions.TransferRunFieldRowTransferValueCasingOnAllUnVisitedCompsByFieldId](ctx: any, fieldId: number) {
            const getterComps = store.getters[Getters.CompAddresses.Comps];
            for (const idx in getterComps.filter((obj: { hasVisited: boolean }) => !obj.hasVisited)) {
                const comp = getterComps[idx];

                store.dispatch(Actions.CompAddresses.TransferRunFieldRowTransferValueCasingOnCompsProcess, {
                    comp: comp,
                    fieldId: fieldId,
                });
            }
        },
        async [CompAddressActions.TransferRunFieldRowTransferValueCasingOnCompsProcess](ctx: any, payload: any) {
            const comp = payload.comp;
            const fieldId = payload.fieldId;

            if (Utils.isKeyInObject(comp, 'sourceData')) {
                const compIdx = comp.sourceData.findIndex((f: any) => f.fieldId === fieldId);
                if (compIdx !== -1) {
                    const fieldData = await FormsManager.getFieldDataById(fieldId);

                    const preferredCasing = fieldData?.preferredCasing || 'Lower';
                    const value = GridColumnUtils.transferValueCasing(comp.sourceData[compIdx]['value'], preferredCasing);

                    const request = newUpsertCompDataRequestByFieldId(comp, fieldId);
                    request.value = value;
                    request.description = 'CompAddressStore.TransferRunFieldRowTransferValueCasingOnCompsProcess()';
                    store.commit(Mutations.CompAddresses.UpsertCompSourceDataByFieldId, request);
                }
            }
        },
        async [CompAddressActions.UseAllData](ctx: any, initials: string) {
            const formFields = await FormsManager.getFormFields();
            const activeComp = computed(() => store.getters[Getters.CompAddresses.ActiveComp]);
            const comp = activeComp.value;

            let fieldRules: IFormFieldRules = [];
            const sourceData = CompUtils.getDataSourceSourceData(comp, initials);
            if (sourceData) {
                fieldRules = GridColumnUtils.getUseAllDataValues(sourceData, formFields);
            }

            store.dispatch(Actions.CompAddresses.ProcessUseAllData, {
                comp: comp,
                fieldRules: fieldRules,
                initials: initials,
                subCompIdx: null,
            });
        },
        async [CompAddressActions.UseAllSubCompData](ctx: any, payload: any) {
            const initials = payload.initials;
            const subCompIdx = payload.subCompIdx;
            const formFields = await FormsManager.getFormFields();
            const activeComp = computed(() => store.getters[Getters.CompAddresses.ActiveComp]);
            const comp = activeComp.value;

            let fieldRules: IFormFieldRules = [];
            const sourceData = CompUtils.getDataSourceSubSourceData(comp, initials, subCompIdx);
            if (sourceData) {
                fieldRules = GridColumnUtils.getUseAllDataValues(sourceData, formFields);
            }

            store.dispatch(Actions.CompAddresses.ProcessUseAllData, {
                comp: comp,
                fieldRules: fieldRules,
                initials: initials,
                subCompIdx: subCompIdx,
            });
        },
        async [CompAddressActions.ProcessUseAllData](ctx: any, payload: any) {
            const comp = payload.comp;
            const submitFieldRules = payload.fieldRules;
            const initials = payload.initials;
            const subCompIdx = payload.subCompIdx;
            if (submitFieldRules.length > 0) {
                const resultFieldRules = await FieldRulesHelper.runFieldRulesForComp(comp, submitFieldRules);
                if (resultFieldRules) {
                    for (const resultFieldRule of resultFieldRules) {

                        // Dont use Comp Photo result from rules endpoint.  URL's should not have casing applied
                        if (resultFieldRule.fieldId === FieldIds.CompPhoto) {
                            resultFieldRule.value = submitFieldRules.find((f: any) => f.fieldId === resultFieldRule.fieldId) ? submitFieldRules.find((f: any) => f.fieldId === resultFieldRule.fieldId).value : resultFieldRule.value;
                        }

                        const request = newUpsertCompDataRequestByFieldId(comp, resultFieldRule.fieldId);
                        request.value = resultFieldRule.value;
                        request.sourceInitial = initials.toLowerCase();
                        request.fieldRulesApplied = resultFieldRule.fieldRulesApplied;
                        request.sourceInitialIdx = subCompIdx;
                        request.description = 'CompAddressStore.ProcessUseAllData()';
                        store.commit(Mutations.CompAddresses.UpsertCompSourceDataByFieldId, request);
                    }
                }
            }
        },
        [CompAddressActions.OnlyShowDiscrepancyRows](ctx: any, isActive: boolean) {
            ctx.commit(CompAddressMutations.OnlyShowDiscrepancyRows, isActive);
        },
        async [CompAddressActions.GenerateFakeData](ctx: any) {
            const fakeSourceData: ISourceData = {};
            const subjectComp = computed(() => store.getters[Getters.CompAddresses.CompByIdx](0));
            const comp = subjectComp.value;

            const formFields = await FormsManager.getFormFields();
            if (!Utils.isObjectEmpty(formFields)) {
                for (const fieldIdx in formFields) {
                    const fieldName = formFields[fieldIdx]['fieldName'];

                    if (fieldName === FieldNames.CompPhoto) continue;

                    const compIdx = comp.sourceData.findIndex((f: any) => f.fieldName === fieldName);
                    if (compIdx !== -1) {
                        fakeSourceData[fieldName] = Utils.ranStr(comp.sourceData[compIdx].value.length);
                    } else {
                        fakeSourceData[fieldName] = Utils.ranStr(7);
                    }
                }

                ctx.commit(CompAddressMutations.SetFakeData, fakeSourceData);
            }
        },
        [CompAddressActions.UpdateInsertNotes](ctx: any, payload: ICommonFieldData) {
            ctx.commit(CompAddressMutations.UpdateInsertNotes, payload);
        },
        [CompAddressActions.ActiveCompFieldFillerCount](ctx: any, count: number) {
            ctx.commit(CompAddressMutations.ActiveCompFieldFillerCount, count);
        },
        [CompAddressActions.ActiveCompSourceCounts](ctx: any, payload: IFeedData[]) {
            ctx.commit(CompAddressMutations.ActiveCompSourceCounts, payload);
        },
    },

    getters: {
        [CompAddressGetters.LocalDatabaseComps](state: any): IComp[] {
            return state.localDatabaseComps ? state.localDatabaseComps : [];
        },
        [CompAddressGetters.Comps](state: any): IComp[] {
            return state.comps ? state.comps : [];
        },
        [CompAddressGetters.CompCount](state: any): number {
            return state.comps ? state.comps.length : 0;
        },
        [CompAddressGetters.HasComps](state: any): boolean {
            return state.hasComps ? state.hasComps : false;
        },
        [CompAddressGetters.ActiveComp](state: any): IComp {
            return state.activeComp ? state.activeComp : {} as IComp;
        },
        [CompAddressGetters.CompByIdx]:
            (state: any) =>
            (compIdx: number): IComp => {
                return state.comps[compIdx] ? state.comps[compIdx] : {} as IComp;
            },
        [CompAddressGetters.CompByAddress]: (state: any) => (compAddress: ICompAddress) => {
            const storeComps: IComps = store.getters[Getters.CompAddresses.Comps];
            const comp = storeComps.find((c) => c.address.address1 === compAddress.address1 && c.address.unitNumber === compAddress.unitNumber && c.address.zipCode === compAddress.zipCode);
            return comp;
        },
        [CompAddressGetters.LocalDatabaseCompByAddress]: (state: any) => (compAddress: ICompAddress) => {
            const storeComps: IComps = store.getters[Getters.CompAddresses.LocalDatabaseComps];
            const comp = storeComps.find((c) => c.address.address1 === compAddress.address1 && c.address.unitNumber === compAddress.unitNumber && c.address.zipCode === compAddress.zipCode);
            return comp;
        },
        [CompAddressGetters.CompIdxByAddress]: (state: any) => (compAddress: ICompAddress) => {
            let compIdx = -1;
            const getterComps = store.getters[Getters.CompAddresses.Comps];
            const itemIdx = getterComps.findIndex((f: any) => f.address.address1 === compAddress.address1 && f.address.unitNumber === compAddress.unitNumber && f.address.zipCode === compAddress.zipCode);
            if (itemIdx !== -1) {
                compIdx = itemIdx;
            }
            return compIdx;
        },
        [CompAddressGetters.ActiveFormCode](state: any) {
            return state.activeFormCode ? state.activeComp.formCode : '1004UAD';
        },
        [CompAddressGetters.GetCompSourceDataValueByFieldName]: (state: any) => (payload: any) => {
            const compIdx = store.getters[Getters.CompAddresses.CompIdxByAddress](payload.comp.address);
            if (compIdx !== -1) {
                const itemIdx = payload.comp.sourceData.findIndex((f: any) => f.fieldName === payload.fieldName);
                if (itemIdx !== -1) {
                    if (Utils.isKeyInObject(payload.comp.sourceData[itemIdx], payload.name)) {
                        return payload.comp.sourceData[itemIdx][payload.name];
                    }
                }
            }
            return null;
        },
        [CompAddressGetters.GetCompSourceDataValueByFieldId]: (state: any) => (payload: any) => {
            const compIdx = store.getters[Getters.CompAddresses.CompIdxByAddress](payload.comp.address);
            if (compIdx !== -1) {
                const itemIdx = payload.comp.sourceData.findIndex((f: any) => f.fieldId === payload.fieldId);
                if (itemIdx !== -1) {
                    if (Utils.isKeyInObject(payload.comp.sourceData[itemIdx], payload.name)) {
                        return payload.comp.sourceData[itemIdx][payload.name];
                    }
                }
            }
            return null;
        },
        [CompAddressGetters.GetAllDataPointsByFieldId]: (state: any) => (fieldName: string[]) => {
            const result = [];
            const active = { ...state.activeComp };
            const formFields = formFieldsStore.FormFields;

            // This will dynamically grad all data sources key names collected
            const dataSources = Object.keys(active).filter((key) => key.includes('sourceData'));

            for (const idx in fieldName) {
                const field = fieldName[idx];

                let selectedData = {};
                const sourceData = [];
                for (const sourceIdx in dataSources) {
                    const dataSource = dataSources[sourceIdx];

                    // Transfer Data: sourceData
                    if (dataSource.length === 10) {
                        const rowIdx = state.activeComp[dataSource].findIndex((f: any) => f.fieldName === field);
                        if (rowIdx !== -1) {
                            const rowItem = state.activeComp[dataSource][rowIdx];
                            if (rowItem.value !== '') {
                                selectedData = {
                                    value: rowItem.value,
                                    fieldRulesApplied: false, // TODO: Need to add fieldRulesApplied property to each field in the sourceData payload and reference
                                    sourceInitial: rowItem.sourceInitial === '' ? SourceDataInitials.FormFiller : rowItem.sourceInitial.toLowerCase(),
                                };
                            }
                        }

                        // All other sources: sourceDataPR, sourceDataSE, etc
                    } else {
                        if (!Utils.isObjectEmpty(state.activeComp[dataSource])) {
                            if (Utils.isKeyInObject(state.activeComp[dataSource], 'sourceData')) {
                                if (Utils.isKeyInObject(state.activeComp[dataSource]['sourceData'], field)) {
                                    if (state.activeComp[dataSource]['sourceData'][field] !== '' && state.activeComp[dataSource]['sourceData'][field] !== null) {
                                        sourceData.push({
                                            value: state.activeComp[dataSource]['sourceData'][field],
                                            sourceInitial: dataSource.slice(10).toLowerCase(),
                                        });
                                    }
                                }
                            }
                        }
                    }
                }

                let friendlyFieldName = '';
                let fieldId = 0;
                const fieldIdx = formFields.findIndex((f: any) => f.fieldName === field);
                if (fieldIdx !== -1) {
                    friendlyFieldName = formFields[fieldIdx]['friendlyFieldName'];
                    fieldId = formFields[fieldIdx]['fieldId'];
                }

                const fieldData = {
                    fieldName: field,
                    fieldId: fieldId,
                    friendlyFieldName: friendlyFieldName,
                    selectedData: selectedData,
                    sourceData: sourceData,
                };

                result.push(fieldData);
            }

            return result;
        },
        [CompAddressGetters.ActiveCompFieldData]: (state: any) => (fieldName: string) => {
            let result = {};
            const idx = state.activeComp.sourceData.findIndex((f: any) => f.fieldName === fieldName);
            if (idx !== -1) {
                result = state.activeComp.sourceData[idx];
            }
            return result;
        },
        [CompAddressGetters.OnlyShowDiscrepancyRows](state: any): boolean {
            return state.onlyShowDiscrepancyRows;
        },
        [CompAddressGetters.ActiveCompEmptySourceData](state: any): string[] {
            const sourceDataEmpty: string[] = [];
            const activeComp = state.activeComp;
            if (!activeComp || typeof activeComp !== 'object') {
                return sourceDataEmpty;
            }
            const emptySources = Object.keys(activeComp)
                .filter(function (k) {
                    return k.indexOf('source') === 0;
                })
                .reduce(function (newData: any, k) {
                    newData[k] = activeComp[k];
                    return newData;
                }, {});

            for (const sourceProperyName in emptySources) {
                const initials = sourceProperyName.slice(10);
                if (initials) {
                    if (Utils.isKeyInObject(activeComp, sourceProperyName)) {
                        if (!Utils.isObjectEmpty(activeComp[sourceProperyName])) {
                            if (Utils.isKeyInObject(activeComp[sourceProperyName], 'sourceData')) {
                                if (Utils.isObjectEmpty(activeComp[sourceProperyName].sourceData)) {
                                    sourceDataEmpty.push(initials);
                                }
                            }
                        } else {
                            sourceDataEmpty.push(initials);
                        }
                    }
                }
            }

            return sourceDataEmpty;
        },
        [CompAddressGetters.GetFakeData](state: any): ISourceData {
            return state.fakeData ? state.fakeData : {};
        },
        [CompAddressGetters.ActiveCompFieldFillerCount](state: any): number {
            return state.activeCompFieldFillerCount ? state.activeCompFieldFillerCount : 0;
        },
        [CompAddressGetters.ActiveCompSourceCounts](state: any): IFeedData[] {
            return state.activeCompSourceCounts ? state.activeCompSourceCounts : [];
        },
        [CompAddressGetters.IsSEColumnCollasped](state: any): boolean {
            return state.activeCompIsSECollapsed;
        },
        [CompAddressGetters.IsDBColumnCollasped](state: any): boolean {
            return state.activeCompIsDBCollapsed;
        },
    },

    mutations: {
        [CompAddressMutations.LocalDatabaseComps](state: any, comp: IComp) {
            state.localDatabaseComps.push(comp);
        },
        [CompAddressMutations.UpdateComp](state: any, comp: IComp) {
            state.comps.push(comp);
        },
        [CompAddressMutations.UpdateHasComps](state: any, value: boolean) {
            state.hasComps = value;
        },
        [CompAddressMutations.UpdateCompFeedData](state: any, updateRequest: UpdateFeedRequest) {
            const itemIdx = state.comps.findIndex((f: any) => f.qsGuid === updateRequest.qsGuid);
            if (itemIdx !== -1) {
                switch (updateRequest.sourceInitial.toLowerCase()) {
                    case SourceDataInitials.Database:
                        state.comps[itemIdx].sourceDataDB = updateRequest.feedData;
                        break;
                    case SourceDataInitials.SmartExchange:
                        state.comps[itemIdx].sourceDataSE = updateRequest.feedData;
                        break;
                    case SourceDataInitials.PublicRecords:
                        state.comps[itemIdx].sourceDataPR = updateRequest.feedData;
                        break;
                    case SourceDataInitials.Mls:
                        state.comps[itemIdx].sourceDataMLS = updateRequest.feedData;
                        break;
                }
            }
        },
        [CompAddressMutations.UpdateLocalVersions](state: any, payload: any) {
            const itemIdx = state.comps.findIndex((f: any) => f.qsGuid === payload.qsGuid);
            if (itemIdx !== -1) {
                state.comps[itemIdx].localVersions = payload.localVersions;
            }
        },
        [CompAddressMutations.ResetCompLoading](state: any, qsGuid: string) {
            const itemIdx = state.comps.findIndex((f: any) => f.qsGuid === qsGuid);
            if (itemIdx !== -1) {
                state.comps[itemIdx].isLoading = false;
            }
        },
        [CompAddressMutations.UpdateRemoveComp](state: any, idx: number) {
            state.comps.splice(idx, 1);
        },
        [CompAddressMutations.UpdateMoveComp](state: any, indexes: DoubleIndex) {
            state.comps = Utils.moveArrayItem(state.comps, indexes.source, indexes.target);
        },
        [CompAddressMutations.UpdateActiveComp](state: any, idx: number) {
            if (Utils.isKeyInObject(state.comps, idx)) {
                state.comps[idx].isActive = true;
                state.activeComp = state.comps[idx];
            } else {
                state.comps[0].isActive = true;
                state.activeComp = state.comps[0];
            }
            state.activeComp.hasVisited = true;
        },
        [CompAddressMutations.ResetActiveComp](state: any) {
            for (const idx in state.comps) {
                state.comps[idx].isActive = false;
            }
        },
        [CompAddressMutations.ResetCompNumber](state: any) {
            for (const idx in state.comps) {
                state.comps[idx].compNumber = Number(idx);
            }
        },
        [CompAddressMutations.UpsertCompSourceDataByFieldId](state: any, request: IUpsertCompDataRequest) {
            const storeComp: IComp = store.getters[Getters.CompAddresses.CompByAddress](request.comp.address);

            if (storeComp) {
                if (!storeComp.sourceData) {
                    storeComp.sourceData = [];
                }

                const compData = storeComp.sourceData.find((cd) => cd.fieldId === request.fieldId);
                if (compData) {
                    // const logMsg = `CompAddressStore.UpsertCompSourceDataByFieldId() ${request.description ? 'from ' + request.description : ''}, address[${CompAddressUtils.getShortDescription(request.comp.address)}]`;
                    // if (request.fieldName !== FieldNames.CompPhoto) {
                    //     console.log(`${logMsg}, field[${request.fieldId}], request[${JSON.stringify(_.omit(request, ['comp', 'description']))}]`);
                    // } else {
                    //     console.log(`${logMsg}, field[${request.fieldId},COMP_PHOTO], request[${JSON.stringify(_.omit(request, ['comp', 'description', 'value']))}]`);
                    // }
                    _.assign(compData, _.omit(request, ['comp', 'description']));
                } else {
                    console.log(`CompAddressStore.UpsertCompSourceDataByFieldId() ${request.description ? 'from ' + request.description : ''}, address[${CompAddressUtils.getShortDescription(request.comp.address)}], Store comp data not found for field[${request.fieldId}]`);
                }
            } else {
                console.log(`CompAddressStore.UpsertCompSourceDataByFieldId() ${request.description ? 'from ' + request.description : ''}, address[${CompAddressUtils.getShortDescription(request.comp.address)}], Store comp not found`);
            }
        },
        [CompAddressMutations.UpsertCompSourceDataByFieldName](state: any, request: IUpsertCompDataRequest) {
            const storeComp: IComp = store.getters[Getters.CompAddresses.CompByAddress](request.comp.address);

            if (storeComp) {
                if (!storeComp.sourceData) {
                    storeComp.sourceData = [];
                }

                // const logMsg = `CompAddressStore.UpsertCompSourceDataByFieldName() ${request.description ? 'from ' + request.description : ''}, address[${CompAddressUtils.getShortDescription(request.comp.address)}]`;

                let compData = storeComp.sourceData.find((cd) => cd.fieldName === request.fieldName);
                if (compData) {
                    // if (request.fieldName !== FieldNames.CompPhoto) {
                    //     console.log(`${logMsg}, Updating field[${request.fieldName}], request[${JSON.stringify(_.omit(request, ['comp', 'description']))}]`);
                    // } else {
                    //     console.log(`${logMsg}, Updating field[${request.fieldName},COMP_PHOTO], request[${JSON.stringify(_.omit(request, ['comp', 'description', 'value']))}]`);
                    // }

                    _.assign(compData, _.omit(request, ['comp', 'description']));
                } else {
                    // if (request.fieldName !== FieldNames.CompPhoto) {
                    //     console.log(`${logMsg}, Adding field[${request.fieldName}], request[${JSON.stringify(_.omit(request, ['comp', 'description']))}]`);
                    // } else {
                    //     console.log(`${logMsg}, Adding field[${request.fieldName},COMP_PHOTO], request[${JSON.stringify(_.omit(request, ['comp', 'description', 'value']))}]`);
                    // }

                    compData = newCompData();
                    _.assign(compData, _.omit(request, ['comp', 'description']));
                    storeComp.sourceData.push(compData);
                }
            } else {
                console.log(`CompAddressStore.UpsertCompSourceDataByFieldName() ${request.description ? 'from ' + request.description : ''}, address[${CompAddressUtils.getShortDescription(request.comp.address)}], Store comp not found`);
            }
        },
        [CompAddressMutations.UpsertCompSourceDataValueByFieldName](state: any, payload: any) {
            const compIdx = store.getters[Getters.CompAddresses.CompIdxByAddress](payload.comp.address);
            if (compIdx !== -1) {
                const itemIdx = payload.comp.sourceData.findIndex((f: any) => f.fieldName === payload.fieldName);
                if (itemIdx !== -1) {
                    state.comps[compIdx].sourceData[itemIdx][payload.name] = payload.value;
                } else {
                    state.comps[compIdx].sourceData.push({ fieldName: payload.fieldName });
                }
            }
        },
        [CompAddressMutations.AddCompData](state: any, payload: IAddCompDataRequest) {
            const compIdx = store.getters[Getters.CompAddresses.CompIdxByAddress](payload.compAddress);
            if (compIdx === -1) {
                return;
            }

            const stateComp: IComp = state.comps[compIdx];
            if (!stateComp.sourceData) {
                stateComp.sourceData = [];
            }

            for (const compData of payload.compDatas) {
                // No duplicates, so check existence by field name (not all have a field id)
                const idx = stateComp.sourceData.findIndex((cd) => cd.fieldName === compData.fieldName);
                if (idx === -1) {
                    // console.log(`CompAddressStore.AddCompData(), address[${CompAddressUtils.getShortDescription(payload.compAddress)}], compData[${JSON.stringify(compData)}]`);
                    stateComp.sourceData.push(compData);
                }
            }
        },
        [CompAddressMutations.UpdateCompMLS](state: any, payload: any) {
            state.comps[payload.idx].sourceDataMLS = payload.mlsData;
        },
        [CompAddressMutations.OnlyShowDiscrepancyRows](state: any, isActive: boolean) {
            state.onlyShowDiscrepancyRows = isActive;
        },
        [CompAddressMutations.UpdateAdditionalField](state: any, payload: any) {
            const comp = state.comps[0];
            const request = newUpsertCompDataRequestByFieldName(comp, payload.fieldName);
            request.value = payload.value;
            request.description = 'CompAddressStore.UpdateAdditionalField()';
            store.commit(Mutations.CompAddresses.UpsertCompSourceDataByFieldName, request);
        },
        [CompAddressMutations.SetFakeData](state: any, sourceData: ISourceData) {
            state.fakeData = sourceData;
        },
        [CompAddressMutations.UpdateInsertNotes](state: any, payload: ICommonFieldData) {
            if (state.activeComp.notesData) {
                const itemIdx = state.activeComp.notesData.findIndex((x: { fieldName: { toString: () => any } }) => x.fieldName === payload.fieldName);
                if (itemIdx !== -1) {
                    state.activeComp.notesData[itemIdx] = payload;
                } else {
                    state.activeComp.notesData.push(payload);
                }
            } else {
                // notesData is null.  Notes have never been saved
                state.activeComp.notesData = [];
                state.activeComp.notesData.push(payload);
            }
        },
        [CompAddressMutations.ActiveCompFieldFillerCount](state: any, count: number) {
            state.activeCompFieldFillerCount = count;
        },
        [CompAddressMutations.ActiveCompSourceCounts](state: any, payload: IFeedData[]) {
            state.activeCompSourceCounts = payload;
        },
        [CompAddressMutations.AddSubComp](state: any, payload: any) {
            const idx = store.getters[Getters.CompAddresses.CompIdxByAddress](payload.comp.address);
            if (idx !== -1) {
                if (!state.comps[idx].subCompData) {
                    state.comps[idx].subCompData = {};
                }

                if (!Utils.isKeyInObject(state.comps[idx].subCompData, payload.initials)) {
                    state.comps[idx].subCompData[payload.initials] = [];
                }

                state.comps[idx].subCompData[payload.initials].push(payload.sourceData);
            }
        },
        [CompAddressMutations.ClearSubComps](state: any, payload: any) {
            const idx = store.getters[Getters.CompAddresses.CompIdxByAddress](payload.comp.address);
            if (idx !== -1) {
                if (state.comps[idx].subCompData && Utils.isKeyInObject(state.comps[idx].subCompData, payload.initials)) {
                    delete state.comps[idx].subCompData[payload.initials];
                }
            }
        },

        [CompAddressMutations.SetSEColumnCollasped](state: any, value: boolean) {
            state.activeCompIsSECollapsed = value;
        },
        [CompAddressMutations.SetDBColumnCollasped](state: any, value: boolean) {
            state.activeCompIsDBCollapsed = value;
        },
        [CompAddressMutations.ClearCompSourceData](state: any, payload: IClearSourceDataRequest) {
            const comp: IComp = store.getters[Getters.CompAddresses.CompByAddress](payload.comp.address);
            if (comp) {
                for (const sourceInitial of payload.sourceInitials) {
                    // console.log(`CompAddressStore.ClearCompSourceData, Clearing [${sourceInitial}] feed data on[${CompAddressUtils.getShortDescription(comp.address)}]`);

                    switch (sourceInitial) {
                        case SourceDataInitials.PublicRecords:
                            if (comp.sourceDataPR && comp.sourceDataPR.sourceData) {
                                const keys = Object.keys(comp.sourceDataPR.sourceData);
                                for (const key of keys) {
                                    comp.sourceDataPR.sourceData[key] = '';
                                }
                            }
                            break;
                        case SourceDataInitials.Mls:
                            if (comp.sourceDataMLS && comp.sourceDataMLS.sourceData) {
                                const keys = Object.keys(comp.sourceDataMLS.sourceData);
                                for (const key of keys) {
                                    comp.sourceDataMLS.sourceData[key] = '';
                                }
                            }
                            break;
                        case SourceDataInitials.SmartExchange:
                            if (comp.sourceDataSE && comp.sourceDataSE.sourceData) {
                                const keys = Object.keys(comp.sourceDataSE.sourceData);
                                for (const key of keys) {
                                    comp.sourceDataSE.sourceData[key] = '';
                                }
                            }
                            break;
                        case SourceDataInitials.Database:
                            if (comp.sourceDataDB && comp.sourceDataDB.sourceData) {
                                const keys = Object.keys(comp.sourceDataDB.sourceData);
                                for (const key of keys) {
                                    comp.sourceDataDB.sourceData[key] = '';
                                }
                            }
                            break;
                    }
                }
            }
        },
    },
};
